'use client'
import {
  Common,
  dynamic,
  HttpService,
  Messages,
  // ReactFlagsSelect,
  RingBuilder,
  ServiceEndpoints
} from '@/config/NextImport'
import { decryptData } from '@/constants/Common'
import { addToCart, getCartProducts } from '@/lib/features/cartSlice'
import { setRingBuilderReady } from '@/lib/features/ringBuilderSlice'
import { AppDispatch, AppState } from '@/lib/store'
import { useRouter, useSearchParams } from 'next/navigation'
import { Fragment, useEffect, useState } from 'react'
import Select from 'react-dropdown-select'
import { useDispatch, useSelector } from 'react-redux'
import { Tooltip } from 'react-tooltip'
import KlarnaMessaging from '../KlarnaMessaging'
import { getPriceColumnFromServer } from '../../lib/priceColumn'
// import Swal from 'sweetalert2'
const BackLinkSection = dynamic(() => import('./BackLinkSection'))
const ReviwSkeleton = dynamic(() => import('./ReviwSkeleton'))
const ProductImages = dynamic(() => import('./ProductImages'))
const ProductPrice = dynamic(() => import('@/components/common/ProductPrice'))
const DropHint = dynamic(() => import('@/components/common/DropHint'))
const WishlistIcon = dynamic(() => import('@/components/common/WishlistIcon'), {
  ssr: false,
  loading: () => {
    return (
      <img
        src={Common.setImagePath('assets/images/icon/wishlist.svg')}
        alt="wishlist-icon"
      />
    )
  }
})
const ReactFlagsSelect = dynamic(() => import('react-flags-select'), {
  ssr: false, // Prevents server-side errors since this uses browser APIs
  loading: () => <div className="h-10 w-40 animate-pulse bg-gray-200" /> // Optional: a placeholder
})
const Review = () => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const dispatch = useDispatch<AppDispatch>()
  let obj = {
    setting_sku: '',
    diamond_sku: ''
  }
  const [loading, setLoading] = useState<boolean>(true)
  const [reviewProducts, setReviewProducts] = useState<any>([])
  const [productSizesArray, setproductSizesArray] = useState<any>([])
  const [productSizes, setProductSizes] = useState<any>([])
  const [countries, setcountries] = useState<any>([])
  const [selectedCountry, setselectedCountry] = useState<any>()
  const [selectedRingSizeId, SetselectedRingSizeId] = useState<any>([])
  const [BackURL, setBackURL] = useState<string>('')
  const { cartListProducts } = useSelector((state: AppState) => state.cart)
  const { userData } = useSelector((state: AppState) => state.user)
  const [isClient, setIsClient] = useState(false)
  const [isExistInCart, setIsExistInCart] = useState<boolean>(false)
  const { isRingBuilderReady } = useSelector((state: AppState) => state.ringBuilder)
  const priceColumn = getPriceColumnFromServer()

  const [currencyData, setCurrencyData] = useState<any>([])
  const [productError, setProductError] = useState(false)
  if (reviewProducts.length !== 0) {
    obj.diamond_sku = reviewProducts.products
      .filter((x: any) => x.is_diamond === 1)
      .map((item: any) => item.sku)
    obj.setting_sku = reviewProducts.products
      .filter((x: any) => x.is_diamond === 0)
      .map((item: any) => item.sku)
  }

  useEffect(() => {
    const cartData = JSON.parse(decryptData(localStorage.getItem(Messages.CartProducts) || '[]'))
    const productExistsInCart =
      cartData &&
      cartData.find(
        (x: any) =>
          x.setting_sku === searchParams.get('s') && x.diamond_sku === searchParams.get('j')
      )
    setIsExistInCart(!!productExistsInCart)
    getReviewProducts(cartData) // pass the data directly
    setIsClient(true)
    const currency = JSON.parse(Common.decryptData(localStorage.getItem(Messages.Currency)))
    if (currency) {
      setCurrencyData(
        currency.filter((item: any) => item.Code === priceColumn.replace('_price', ''))
      )
    }
  }, [])

  const startNewFlow = (url: any) => {
    RingBuilder.removeRingBuilder()
    router.push(url)
  }

  const getReviewProducts = async (cartData: any) => {
    const storageSteps: any = RingBuilder.getRingBuilder()
    const setting = storageSteps.filter((item: any) => item.step === 'setting')
    const param = {
      sku: searchParams.get('s') + ',' + searchParams.get('j'),
      setting_default_shape:
        setting.length > 0 && setting[0].product?.setting_default_shape
          ? setting[0]?.product.setting_default_shape
          : ''
    }
    setLoading(true)

    try {
      const response = await HttpService.postApi(ServiceEndpoints.getReviewProducts, param)
      if (!response?.result?.products?.length) {
        setProductError(true)
        setLoading(false)
        return
      }

      if (response.result) {
        const data = response.result
        if (data !== undefined) {
          obj.diamond_sku = data.products
            .filter((x: any) => x.is_diamond === 1)
            .map((item: any) => item.sku)
          obj.setting_sku = data.products
            .filter((x: any) => x.is_diamond === 0)
            .map((item: any) => item.sku)
        }
        setReviewProducts(response.result)
        const storageSteps: any = RingBuilder.getRingBuilder()
        // const diamondUrl = storageSteps
        //   .filter((item) => item.step === 'diamond')[0]
        //   .url.split('?')[0]
        const diamondDetail = data.products.filter((item: any) => {
          return item.is_diamond === 1
        })[0]
        const settingDetail = data.products.filter((item: any) => {
          return item.is_diamond !== 1
        })[0]

        const diamondSku = diamondDetail.sku
        setproductSizesArray(settingDetail.sizeArray)
        if (settingDetail.sizeArray.length !== 0) {
          setProductSizes(
            settingDetail.sizeArray.filter((x: any) => x.country_code === 'GB')[0]?.sizes
          )
          setcountries(settingDetail.sizeArray.map((x: any) => x.country_code))
          setselectedCountry(
            settingDetail.sizeArray.filter((x: any) => x.country_code === 'GB')[0].country_code
          )
          const value = settingDetail.sizeArray.filter((x: any) => x.country_code === 'GB')[0]
            ?.sizes[0]
          SetselectedRingSizeId({ value: value, label: value })
        }

        if (cartData && cartData.length > 0) {
          const value = cartData
            .filter(
              (x: any) =>
                x.setting_sku === obj.setting_sku[0] && x.diamond_sku === obj.diamond_sku[0]
            )
            .map((item: any) => item.size_id)
          if (value.length !== 0) SetselectedRingSizeId({ value: value[0], label: value[0] })
          const countryValue = cartData
            .filter(
              (x: any) =>
                x.setting_sku === obj.setting_sku[0] && x.diamond_sku === obj.diamond_sku[0]
            )
            .map((item: any) => item.size_country)

          if (countryValue.length !== 0) {
            setselectedCountry(countryValue[0])
            setProductSizes(
              settingDetail.sizeArray.filter((x: any) => x.country_code === countryValue[0])[0]
                ?.sizes
            )
          }
        }
        storageSteps.map((innerStep: any) => {
          if (innerStep.step === 'diamond') {
            const diamondData = {
              attribute_options: diamondDetail.attribute_options,
              category_ids: diamondDetail.category_ids,
              price: diamondDetail.price,
              special_price: diamondDetail.special_price,
              formated_price: diamondDetail.formated_price,
              formated_special_price: diamondDetail.formated_special_price,
              image: diamondDetail.base_image,
              name: diamondDetail.name,
              is_sold: diamondDetail.is_sold,
              is_diamond: diamondDetail.is_diamond,
              is_gemstone: diamondDetail.is_gemstone,
              default_image: diamondDetail?.default_image
            }
            innerStep.IsCompleted = true
            innerStep.IsChange = false
            innerStep.IsActive = false
            innerStep.selected_productid = diamondSku
            innerStep.url = settingDetail.diamond_url.split('?')[0]
            innerStep.product = diamondData
            innerStep.IsView = false
            innerStep.detail_url =
              settingDetail.diamond_url.split('?')[0] +
              '/' +
              diamondDetail.name.replace(/ /g, '-').toLowerCase() +
              '-sku-' +
              diamondSku
          } else if (innerStep.step === 'setting') {
            const settingData = {
              attribute_options: settingDetail.attribute_options,
              can_be_set_with: settingDetail.can_be_set_with,
              category_ids: settingDetail.category_ids,
              price: settingDetail.price,
              special_price: settingDetail.special_price,
              formated_price: settingDetail.formated_price,
              formated_special_price: settingDetail.formated_special_price,
              image: settingDetail.base_image,
              name: settingDetail.name,
              setting_default_shape: settingDetail.defaultShape,
              model_number: settingDetail.model_number,
              selected_standalone_options: setting[0]?.product?.selected_standalone_options
            }
            innerStep.selected_productid = settingDetail.sku
            innerStep.product = settingData
            innerStep.IsCompleted = true
            innerStep.IsChange = false
            innerStep.IsActive = false
            innerStep.detail_url =
              diamondDetail.setting_url.split('?')[0] +
              '/' +
              settingDetail.name.replace(/ /g, '-').toLowerCase() +
              '-sku-' +
              settingDetail.sku
            innerStep.url = diamondDetail.setting_url.split('?')[0]
            innerStep.IsView = false
          } else if (innerStep.step === 'review') {
            innerStep.IsActive = true
            innerStep.IsChange = false
            innerStep.IsView = true
            innerStep.selected_productid = data?.sku

            innerStep.product = []
            /// make it false when user go for view from steps
            innerStep.url =
              data.complete_jewel_slug + '?j=' + diamondSku + '&s=' + settingDetail.sku
          }
          return true
        })
        RingBuilder.setRingBuilder(storageSteps)
        dispatch(setRingBuilderReady(!isRingBuilderReady))
        if (storageSteps.filter((x: any) => x.stepno === 2).length > 0)
          setBackURL(storageSteps.filter((x: any) => x.stepno === 2)[0].url)
        setLoading(false)
      }
      setLoading(false)
    } catch (error) {
      console.error(error)
      setProductError(true)
      setLoading(false)
    }
  }
  const swapSteps = (Steps: any) => {
    const updatedSteps = []
    const step1 = Steps.filter((x: any) => x.stepno === 2)
    const step2 = Steps.filter((x: any) => x.stepno === 1)
    const step3 = Steps.filter((x: any) => x.stepno === 3)
    updatedSteps.push(step1[0])
    updatedSteps.push(step2[0])
    updatedSteps.push(step3[0])
    updatedSteps[0].stepno = 1
    updatedSteps[1].stepno = 2
    updatedSteps[0].class = 'first-step'
    updatedSteps[1].class = 'second-step'
    return updatedSteps
  }

  const changeStep = (step: any, isView: boolean, url: string) => {
    let steps: any = RingBuilder.getRingBuilder()
    const stepDetail = steps.filter((x: any) => x.step === step)
    const stepno = stepDetail[0].stepno
    if (stepno === 1) {
      steps = swapSteps(steps)
    }
    steps.map((item: any) => {
      if (item.stepno === stepno) {
        item.IsActive = true
        if (isView) {
          item.IsView = true
          item.IsChange = false
        } else {
          item.IsView = false
          item.IsChange = true
        }
      } else {
        item.IsActive = false
        item.IsView = false
        item.IsChange = false
      }
      return true
    })
    RingBuilder.setRingBuilder(steps)
    router.push(url)
  }

  const handleCountrydropdown = (e: any) => {
    setselectedCountry(e)
    if (e !== undefined && e !== null) {
      const Sizes = productSizesArray.filter((x: any) => x.country_code === e)[0].sizes
      setProductSizes(Sizes)
      SetselectedRingSizeId({ label: Sizes[0], value: Sizes[0] })
    }
    const products = Common.GetJSON(Common.decryptData(localStorage.getItem(Messages.CartProducts)))
    for (const key in products) {
      if (
        products[key].setting_sku === obj.setting_sku[0] &&
        products[key].diamond_sku === obj.diamond_sku[0]
      ) {
        products[key].size_country = e
      }
    }
    localStorage[Messages.CartProducts] = Common.encryptData(JSON.stringify(products))
  }

  const handleRingSize = (value: any) => {
    SetselectedRingSizeId(value[0])
    const products = Common.GetJSON(Common.decryptData(localStorage.getItem(Messages.CartProducts)))
    for (const key in products) {
      if (
        products[key].setting_sku === obj.setting_sku[0] &&
        products[key].diamond_sku === obj.diamond_sku[0]
      ) {
        products[key].size_id = value[0].value
      }
    }
    localStorage[Messages.CartProducts] = Common.encryptData(JSON.stringify(products))
  }

  const addProductToCart = async () => {
    const storageSteps: any = RingBuilder.getRingBuilder()
    const settingData = storageSteps.filter((x: any) => x.step === 'setting')[0]

    const canbeset = reviewProducts.products.filter((x: any) => x.is_diamond === 0)[0]
      .can_be_set_with

    const shape = reviewProducts.products
      .filter((x: any) => x.is_diamond === 1)[0]
      .attribute_options.filter((x: any) => x.title.toLowerCase() === 'shape')
    const carat = reviewProducts.products
      .filter((x: any) => x.is_diamond === 1)[0]
      .attribute_options.filter((x: any) => x.title.toLowerCase() === 'carat')

    const checkShape = canbeset.filter(
      (x: any) =>
        x.shape.toLowerCase() === shape[0].value.toLowerCase() &&
        parseFloat(x.carat_from) <= parseFloat(carat[0].value) &&
        parseFloat(carat[0].value) <= parseFloat(x.carat_to)
    )

    if (checkShape.length > 0) {
      const productDetail = {
        setting_sku: obj.setting_sku[0],
        diamond_sku: obj.diamond_sku[0]
      }
      let ringSize = selectedRingSizeId.value

      if (selectedRingSizeId.length === 0) {
        ringSize = productSizes.length !== 0 ? productSizes[0].value : 0
      }
      let standaloneOptions = null
      let standaloneAttributes
      if (cartListProducts?.products && cartListProducts?.products.length) {
        standaloneAttributes = cartListProducts?.products
          .filter(
            (x: any) => x.setting_sku === obj.setting_sku[0] && x.diamond_sku === obj.diamond_sku[0]
          )
          .map((item: any) => item.standalone_options)
      }
      if (
        standaloneAttributes !== undefined &&
        standaloneAttributes !== null &&
        standaloneAttributes.length !== 0
      ) {
        standaloneOptions = JSON.stringify(standaloneAttributes[0])
      } else {
        standaloneOptions = settingData?.product?.selected_standalone_options
      }

      await dispatch(
        addToCart({
          item: productDetail,
          ringSizeId: ringSize,
          user: userData.user,
          country: selectedCountry,
          standaloneOptions
        })
      )
      await dispatch(getCartProducts())
      RingBuilder.getRingBuilder()
      RingBuilder.removeRingBuilder()
      router.push('/cart')
    } else {
      const Swal = (await import('sweetalert2')).default
      const isGemstone = reviewProducts?.products.filter((item: any) => item.is_gemstone).length > 0
      Swal.fire({
        title: Messages.diamond_not_compatible,
        text: isGemstone
          ? Messages.GemstoneRingBuilderShapeNotMatch
          : Messages.RingBuilderShapeNotMatch
      })
    }
  }
  return (
    <div className="container">
      {productError ? <></> : <BackLinkSection BackURL={BackURL} />}
      {loading || !isClient ? (
        <ReviwSkeleton />
      ) : productError ? (
        <section className="py-5 bg-light text-center mb-4">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8 col-lg-6">
                <h2 className="fw-semibold mt-5 mb-3">Product Not Available</h2>

                <p className="text-muted mb-4">
                  The item you’re looking for is unavailable or the link is incorrect.
                </p>

                <div className="d-flex justify-content-center gap-3 flex-wrap">
                  <a
                    onClick={() => startNewFlow('/engagement-rings/all-settings')}
                    className="btn btn-custom px-4"
                  >
                    Start with Setting
                  </a>

                  <a
                    onClick={() => startNewFlow('/loose-diamonds/natural-diamonds')}
                    className="btn btn-custom px-4"
                  >
                    Start with Diamond
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        <>
          <div className="row">
            <div className="col-md-6">
              <ProductImages detail={reviewProducts} />
            </div>

            <div className="col-md-6">
              <div className="product-summary-content review-summary-content">
                {' '}
                {/* right products details */}
                <div className="product-summary-top">
                  <div className="product-summary-share-title mb-2">
                    <h1 className="product-summary-title">Review Your Item (Completed)</h1>
                  </div>
                  {reviewProducts?.products?.map(function (item: any, index: number) {
                    if (item.is_diamond) {
                      return (
                        <div
                          className={
                            item.is_sold ? 'product-item replace-cart-item' : 'product-item'
                          }
                          key={item.id}
                        >
                          <img
                            src={Common.setImagePath('assets/images/icon/start_with-diamond.svg')}
                            alt="Diamond"
                            className="product-item-icon"
                          />
                          <div className="product-item-content">
                            <div className="product-item-title">{item.name}</div>
                            <div className="product-item-subcontent">
                              <p className="product-item-sku">
                                <span>
                                  {' '}
                                  {item.model_number !== '' &&
                                  item.model_number !== null &&
                                  item.model_number !== undefined ? (
                                    <> SKU: {item.model_number}</>
                                  ) : (
                                    <>SKU: {item.sku} </>
                                  )}
                                </span>
                              </p>
                              <ul className="product-diamond-summary-list">
                                {Common.GetJSON(item.attribute_options).map(
                                  (attribute: any, index: number) => {
                                    if (
                                      (attribute.title.toLowerCase() === 'cut' ||
                                        attribute.title.toLowerCase() === 'color' ||
                                        attribute.title.toLowerCase() === 'clarity') &&
                                      attribute.value !== null &&
                                      attribute.value !== ''
                                    )
                                      return (
                                        <li key={index}>
                                          {attribute.value + ' ' + attribute.title}
                                        </li>
                                      )
                                    return true
                                  }
                                )}
                              </ul>
                            </div>
                          </div>
                          <div className="product-item-price">
                            {item.is_sold ? (
                              <div className="replace-cart-box">
                                <span
                                  className="replace-btn pointer"
                                  onClick={() => changeStep('diamond', false, item.diamond_url)}
                                >
                                  Replace
                                </span>
                                <div className="btn sold-btn">Sold Out</div>
                              </div>
                            ) : (
                              <div>
                                <span className="product-item-amount amount">
                                  <ProductPrice data={item} />
                                </span>
                                <span
                                  onClick={() => changeStep('diamond', false, item.diamond_url)}
                                  className="change-link"
                                  style={{ cursor: 'pointer' }}
                                >
                                  Change
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      )
                    } else {
                      return (
                        <div
                          className="product-item"
                          key={item.id}
                        >
                          <img
                            src={Common.setImagePath('assets/images/icon/ring.svg')}
                            alt="rings"
                            className="product-item-icon"
                          />
                          <div className="product-item-content">
                            <div className="product-item-title">
                              {item.name !== undefined && Common.toTitleCase(item.name)}
                            </div>
                            <div className="product-item-subcontent">
                              <p className="product-item-sku">
                                <span>
                                  {' '}
                                  {item.model_number !== '' &&
                                  item.model_number !== null &&
                                  item.model_number !== undefined ? (
                                    <> SKU: {item.model_number}</>
                                  ) : (
                                    <>SKU: {item.sku} </>
                                  )}
                                </span>
                              </p>
                            </div>
                          </div>
                          <div className="product-item-price">
                            <span className="product-item-amount amount">
                              <ProductPrice data={item} />
                            </span>
                            <span
                              onClick={() => changeStep('setting', false, item.setting_url)}
                              className="change-link"
                              style={{ cursor: 'pointer' }}
                            >
                              Change
                            </span>
                          </div>
                        </div>
                      )
                    }
                  })}
                </div>
                {countries.length !== 0 && productSizes.length !== 0 && (
                  <div className="row select-size-row">
                    <div className="ring-size-title">Size</div>
                    <div
                      className="select-size-box pe-2"
                      style={{ maxWidth: '240px' }}
                    >
                      <ReactFlagsSelect
                        countries={countries}
                        selected={selectedCountry}
                        fullWidth={true}
                        onSelect={(e) => handleCountrydropdown(e)}
                      />
                    </div>
                    <div
                      className="select-size-box ps-0"
                      style={{ maxWidth: '150px' }}
                    >
                      <Select
                        options={productSizes.map((value: any) => ({
                          label: value,
                          value
                        }))}
                        values={[
                          selectedRingSizeId.length !== 0
                            ? selectedRingSizeId
                            : { label: productSizes[0], value: productSizes[0] }
                        ]}
                        backspaceDelete={false}
                        onChange={(value) => handleRingSize(value)}
                        dropdownHeight="200px"
                        color="#767676"
                        dropdownPosition="auto"
                      />
                    </div>
                  </div>
                )}
                <div className="product-summary-bottom">
                  <div className="product-summary-price">
                    <span>{reviewProducts.subtotal}</span>
                  </div>
                  <div className="product-summary-btn">
                    <button
                      className="btn btn-custom"
                      onClick={() => addProductToCart()}
                      disabled={
                        reviewProducts?.products.filter(
                          (item: any) => item.is_diamond && item.is_sold === 1
                        ).length > 0
                      }
                    >
                      {isExistInCart ? <>Update Your Cart</> : <> Add To Cart</>}
                    </button>
                    <button className="btn wishlist-btn">
                      <WishlistIcon
                        item={{ setting_sku: obj.setting_sku[0], diamond_sku: obj.diamond_sku[0] }}
                        isFromReviewStep={true}
                      />
                    </button>
                    <span
                      className="btn message-btn btn-custom-light"
                      data-bs-toggle="modal"
                      data-bs-target="#DropHintModal"
                      data-backdrop="static"
                      data-keyboard="false"
                    >
                      <img
                        src={Common.setImagePath('assets/images/icon/drop-hint-line.svg')}
                        alt="Drop A Hint"
                      />
                    </span>
                  </div>
                  {currencyData.length > 0 && (
                    <KlarnaMessaging
                      amount={parseFloat(reviewProducts.raw_subtotal) * 100}
                      currency={currencyData.length > 0 ? currencyData[0].currency_name : 'GBP'}
                      countryCode={currencyData.length > 0 ? currencyData[0].Code : 'GB'}
                    />
                  )}

                  <div className="summary-info">
                    <span className="delivery-icon-anim me-2">
                      <img
                        src={Common.setImagePath('assets/images/icon/delivery-icon.svg')}
                        className="delivery-icon me-2"
                        width="22px"
                        alt="Delivery"
                      />
                    </span>
                    <div className="summary-para">
                      <div>
                        {Messages.DeliveryNotes}
                        <a
                          className="tooltip-info cursor"
                          data-tooltip-id="delivery-date"
                          data-tooltip-content={"Delivery date varies according to the selected ring setting and " + (reviewProducts?.products.filter((item: any) => item.is_gemstone).length > 0 ? 'gemstone' : 'diamond') + ". Accurate delivery date is available on the complete ring page."}
                          data-tooltip-place="top"
                          data-tooltip-variant="light"
                        >
                          <svg
                            aria-hidden="true"
                            focusable="false"
                            data-prefix="fas"
                            data-icon="circle-info"
                            className="svg-inline--fa fa-circle-info text-custom"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                          >
                            <path
                              fill="currentColor"
                              d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                            ></path>
                          </svg>
                        </a>
                        <Tooltip id="delivery-date" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="product-detail-bottom">
              <div className="row">
                {reviewProducts?.products?.map(function (item: any, index: number) {
                  if (item.is_diamond) {
                    return (
                      <div
                        className="col-lg-6"
                        key={index}
                      >
                        <div className="product-detail-left diamond-tabs">
                          <div
                            className="accordion"
                            id="Diamond-Detailtab"
                          >
                            <div className="accordion-item">
                              <h2
                                className="accordion-header"
                                id="headingOne"
                              >
                                <button
                                  className="accordion-button"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#diamond-tab1"
                                  aria-expanded="true"
                                  aria-controls="diamond-tab1"
                                >
                                  {reviewProducts?.products.filter((item: any) => item.is_gemstone).length > 0 ? 'Gemstone' : 'Diamond'} Details
                                </button>
                              </h2>
                              <div
                                id="diamond-tab1"
                                className="accordion-collapse collapse show"
                                aria-labelledby="headingOne"
                                data-bs-parent="#accordionExample"
                              >
                                <div className="accordion-body p-0">
                                  <table className="table">
                                    <tbody>
                                      <tr>
                                        <td>SKU</td>
                                        <td>{item.sku}</td>
                                      </tr>
                                      {Common.GetJSON(item.attribute_options).map(function (
                                        attribute: any,
                                        index: number
                                      ) {
                                        if (attribute.value !== '' && attribute.value !== null) {
                                          return (
                                            <tr key={index}>
                                              <td>{attribute.title}</td>
                                              <td>
                                                {attribute.title.toLowerCase() === 'certificate' &&
                                                item.diamond_certificate_pdf !== '' &&
                                                item.diamond_certificate_pdf !== null ? (
                                                  <a
                                                    href={item.diamond_certificate_pdf}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                  >
                                                    {attribute.value}
                                                  </a>
                                                ) : (
                                                  <>{attribute.value}</>
                                                )}
                                              </td>
                                            </tr>
                                          )
                                        }
                                        return true
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  } else {
                    return (
                      <Fragment key={index}>
                        <div className="col-lg-6">
                          <div className="product-detail-left diamond-tabs">
                            <div
                              className="accordion"
                              id="Setting-Detailtab"
                            >
                              <div className="accordion-item">
                                <h2
                                  className="accordion-header"
                                  id="headingOne"
                                >
                                  <button
                                    className="accordion-button"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#setting-tab1"
                                    aria-expanded="true"
                                    aria-controls="setting-tab1"
                                  >
                                    Setting Details
                                  </button>
                                </h2>
                                <div
                                  id="setting-tab1"
                                  className="accordion-collapse collapse show"
                                  aria-labelledby="headingOne"
                                  data-bs-parent="#accordionExample"
                                >
                                  <div className="accordion-body p-0">
                                    <table className="table">
                                      <tbody>
                                        <tr>
                                          <td>SKU</td>
                                          <td>{item.sku}</td>
                                        </tr>
                                        {Common.GetJSON(item.attribute_options)
                                          .filter(
                                            (x: any) =>
                                              x.Is_standalone === 0 && x.show_in_storefront === 1
                                          )
                                          .map(function (attribute: any, index: number) {
                                            return (
                                              <tr key={index}>
                                                <td>{attribute.title}</td>
                                                <td>{attribute.value}</td>
                                              </tr>
                                            )
                                          })}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="product-detail-left diamond-tabs">
                            <div
                              className="accordion"
                              id="can_be_set_tab"
                            >
                              <div className="accordion-item">
                                <h2
                                  className="accordion-header"
                                  id="headingOne"
                                >
                                  <button
                                    className="accordion-button"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#can_be_set-tab1"
                                    aria-expanded="true"
                                    aria-controls="can_be_set-tab1"
                                  >
                                    Can Be Set With
                                  </button>
                                </h2>
                                <div
                                  id="can_be_set-tab1"
                                  className="accordion-collapse collapse show"
                                  aria-labelledby="headingOne"
                                  data-bs-parent="#accordionExample"
                                >
                                  <div className="accordion-body p-0">
                                    <table className="table">
                                      <tbody>
                                        {Common.GetJSON(item.can_be_set_with).map(function (
                                          x: any,
                                          index: number
                                        ) {
                                          return (
                                            <tr key={index}>
                                              <td>{x.shape}</td>
                                              <td>
                                                {parseFloat(x.carat_from).toFixed(2)} -{' '}
                                                {parseFloat(x.carat_to).toFixed(2)}
                                              </td>
                                            </tr>
                                          )
                                        })}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Fragment>
                    )
                  }
                })}
              </div>
            </div>
          </div>
          <DropHint
            data={{
              detail: reviewProducts.products.filter((item: any) => item.is_diamond === 0)[0],
              diamond: reviewProducts.products.filter((item: any) => item.is_diamond === 1)[0]
            }}
          />
        </>
      )}
    </div>
  )
}

export default Review
